import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { usePublicPlans } from '@/features/billing/queries'

import { darkPalette } from '../palette'
import { anim } from '../theme'

export function FinalCta() {
  const { t } = useTranslation()
  const plans = usePublicPlans()
  const trial = plans.data?.trial

  return (
    <section
      style={{
        position: 'relative',
        overflow: 'hidden',
        background: darkPalette.bg,
        color: darkPalette.fgAlt,
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 'auto -10% -40% -10%',
          height: 460,
          pointerEvents: 'none',
        }}
      >
        <div
          data-decor=""
          aria-hidden="true"
          style={{
            position: 'absolute',
            bottom: -120,
            left: '20%',
            width: 600,
            height: 600,
            borderRadius: '50%',
            background: 'radial-gradient(circle, oklch(70% 0.14 233 / 0.4), transparent 62%)',
            filter: 'blur(40px)',
            animation: anim.blobCta,
          }}
        />
      </div>
      <div
        style={{
          position: 'relative',
          maxWidth: 900,
          margin: '0 auto',
          padding: '96px 24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 20,
          textAlign: 'center',
        }}
      >
        <h2
          data-reveal=""
          style={{
            margin: 0,
            fontSize: 'clamp(30px,4vw,50px)',
            lineHeight: 1.06,
            fontWeight: 600,
            letterSpacing: '-0.035em',
            textWrap: 'balance',
          }}
        >
          {t('landing.finalCta.title')}
        </h2>
        <p
          data-reveal=""
          style={{
            margin: 0,
            fontSize: 17.5,
            lineHeight: 1.6,
            color: darkPalette.ctaSubtitle,
            maxWidth: 560,
          }}
        >
          {trial !== undefined && trial.credits > 0
            ? t('landing.finalCta.subtitleTrial', { credits: trial.credits, days: trial.days })
            : t('landing.finalCta.subtitle')}
        </p>
        <div
          data-reveal=""
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            justifyContent: 'center',
            marginTop: 6,
          }}
        >
          <Link
            to="/signup"
            style={{
              fontSize: 16,
              fontWeight: 700,
              padding: '15px 30px',
              borderRadius: 100,
              background: darkPalette.ctaBg,
              color: darkPalette.ctaFg,
              boxShadow: darkPalette.ctaShadow,
            }}
          >
            {t('landing.finalCta.ctaPrimary')}
          </Link>
          <Link
            to="/signup"
            style={{
              fontSize: 16,
              fontWeight: 600,
              padding: '14px 26px',
              borderRadius: 100,
              border: `1px solid ${darkPalette.ctaSecBorder}`,
              color: darkPalette.ctaSecFg,
            }}
          >
            {t('landing.finalCta.ctaSecondary')}
          </Link>
        </div>
      </div>
    </section>
  )
}
